module.exports = __webpack_public_path__ + "img/deposit_ban.png";